// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__RDdb6","title":"Dashboard_title__gEkih","message":"Dashboard_message__3rliG","link":"Dashboard_link__rRhvm"};